module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "AlgorithmPage fullH"
  }, [_c('div', {
    staticClass: "row centerDiv"
  }, [_vm._l((_vm.words), function(w, index) {
    return _c('div', {
      staticClass: "col backEffect",
      class: {
        active: _vm.randNum == w[1]
      },
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'Papers',
            query: {
              algorithmname: _vm.algorithmname,
              title: w[0]
            }
          })
        }
      }
    }, [_c('p', {
      style: ({
        fontSize: (24 - w[1] / 16) + 'px'
      })
    }, [_vm._v(_vm._s(w[0]))])])
  }), _c('div', {
    staticClass: "bigTitleDiv"
  }, [_c('h1', [_vm._v(_vm._s(_vm.algorithmname))]), _c('h5', [_vm._v("by " + _vm._s(_vm.details.author) + ", " + _vm._s(_vm.details.year))])])], 2)]), _c('div', {
    staticClass: "page"
  }, [_c('h2', [_vm._v("Details")]), _c('div', {
    staticClass: "container left-align"
  }, [(_vm.details.imgUrl) ? _c('img', {
    staticClass: "circle",
    staticStyle: {
      "width": "150px",
      "float": "right"
    },
    attrs: {
      "src": _vm.details.imgUrl,
      "alt": "alt"
    }
  }) : _vm._e(), _c('h3', {
    staticClass: "metaName"
  }, [_vm._v(_vm._s(_vm.algorithmname))]), _c('h5', [_c('small', [_vm._v("Author: " + _vm._s(_vm.details.author))])]), _c('h5', [_c('small', [_vm._v("Year of Publication: " + _vm._s(_vm.details.year))])]), _vm._m(0), _c('div', {
    staticClass: "abs"
  }, [_vm._v(_vm._s(_vm.details.abstract || 'No abstract available'))]), _c('p', {
    staticClass: "link center"
  }, [(_vm.details.urlPaper) ? _c('a', {
    attrs: {
      "href": _vm.details.urlPaper
    }
  }, [_vm._v("Read More")]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col m6 s12"
  }, [_vm._m(1), (_vm.firstWords.length > 0) ? _c('center', [_c('p'), _vm._l((_vm.firstWords), function(w) {
    return _c('div', {
      staticClass: "chip",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'Papers',
            query: {
              algorithmname: _vm.algorithmname,
              title: w[0]
            }
          })
        }
      }
    }, [_vm._v(_vm._s(w[0])), _c('small', [_vm._v(" " + _vm._s(Math.floor(w[1] / _vm.firstWords[0][1] * 100) + "%"))])])
  }), _c('p')], 2) : _vm._e()], 1), _c('div', {
    staticClass: "col m6 s12"
  }, [_vm._m(2), _c('center', [_c('p'), _vm._l((_vm.authors), function(a, i) {
    return (a._id.authors && i < 20) ? _c('div', {
      staticClass: "chip",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'Papers',
            query: {
              algorithmname: _vm.algorithmname,
              author: a._id.authors
            }
          })
        }
      }
    }, [_vm._v(_vm._s(a._id.authors)), _c('small', [_vm._v(" " + _vm._s(a.count))])]) : _vm._e()
  }), _c('p')], 2)], 1)])])]), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "PubPerYear"
    }
  }, [_c('h2', [_vm._v("References per year")]), _c('br'), _c('PubPerYear', {
    attrs: {
      "algorithmname": _vm.algorithmname
    }
  }), _c('br')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('small', [_vm._v("Original Paper Abstract:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "center"
  }, [_c('small', [_vm._v("Most used words on titles works:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "center"
  }, [_c('small', [_vm._v("Authors refering this algorihtm:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-161d7531"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Algorithm.vue
// module id = 81
// module chunks = 1